import { Stack } from "@mui/material";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Merchant.InitiateDetail;

type Props = {
  isMerchant: boolean;
};

export const QRInstructions = ({ isMerchant }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={5} px={[1, 15]} height="100%" justifyContent="center">
      {isMerchant ? (
        <InfoBox variant="error" content={t(RESOURCES.UsePaypointWarning)} />
      ) : (
        <InfoBox variant="info" content={t(RESOURCES.QRInstructions)} />
      )}
      <InfoBox variant="warning" content={t(RESOURCES.QRCodeWarning)} />
    </Stack>
  );
};
